export default __webpack_public_path__ + "static/media/G0400.34I-27245_-22621_0.1666263480000.aa2ad65b.jpg";